import type { PaginationProps } from '@shopify/polaris';

export enum GPaginationDirection {
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS',
}

export interface GPaginationProps extends Omit<
  PaginationProps,
  'hasPrevious' | 'onPrevious' | 'hasNext' | 'onNext'
> {
  currentPage: number;
  totalPages: number;
  loading?: boolean;
  handlePageChange: (direction: GPaginationDirection) => void;
}
